export const TENANT_COLLECTION_PREFIX = 'tc';

export function deriveTenantCollectionName(
  tenantId: number | string,
  collectionBaseName: string
): string {
  return `${TENANT_COLLECTION_PREFIX}${tenantId}_${collectionBaseName}`;
}
